export const NAV_STYLES = `
  @keyframes gradient-x {
    0%, 100% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
  }
  
  @keyframes float {
    0%, 100% { transform: translateY(0px) rotate(0deg); }
    33% { transform: translateY(-10px) rotate(5deg); }
    66% { transform: translateY(5px) rotate(-5deg); }
  }
  
  @keyframes fadeInDown {
    from { opacity: 0; transform: translateY(-20px); }
    to { opacity: 1; transform: translateY(0); }
  }
  
  @keyframes fadeInUp {
    from { opacity: 0; transform: translateY(20px); }
    to { opacity: 1; transform: translateY(0); }
  }
  
  .animate-gradient-x {
    background-size: 200% 200%;
    animation: gradient-x 3s ease infinite;
  }
  
  .animate-fadeInDown {
    animation: fadeInDown 0.5s ease forwards;
    opacity: 1;
  }
  
  .animate-fadeInUp {
    animation: fadeInUp 0.5s ease forwards;
    opacity: 1;
  }
  
  .radio-embed-container iframe {
    width: 100% !important;
    border-radius: 8px;
  }

  @keyframes visualizer-pulse {
    0% { height: 4px; opacity: 0.5; }
    100% { height: 14px; opacity: 1; }
  }
`;
